export default "__VITE_ASSET__2ecec411__"